import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  className: PropTypes.string,
};

export default function Logo({ disabledLink = false, className = '' }) {
  const logo = (
    <div className={`w-[150px] ${className}`}>
      <img src="static/logo.svg" alt="Logo" className="w-full" />
    </div>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/" className="block">{logo}</RouterLink>;
}
